import { Link } from '@tanstack/react-router';
import { Search, Bell, Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PulseDot } from '@/components/layout/pulse-dot';
import { SiteSwitcher } from '@/components/layout/site-switcher';
import { useTheme } from '@/hooks/use-theme';
import { useMe } from '@/hooks/use-me';

export function TopBar() {
  const { theme, toggle } = useTheme();
  const { data: me } = useMe();

  const initials = me?.member.email.slice(0, 2).toUpperCase() ?? '··';

  return (
    <header className="sticky top-0 z-50 flex h-14 items-center gap-3 border-b border-border bg-bg-base px-4">
      <Link to="/sites" className="flex items-center gap-2 pr-3 border-r border-border h-8">
        <PulseDot />
        <span className="font-semibold tracking-tight">Pulse</span>
      </Link>

      <SiteSwitcher />

      <button className="ml-auto flex items-center gap-2 rounded-md border border-border bg-bg-surface px-3 py-1.5 text-xs text-text-muted hover:border-border-strong hover:text-text transition-colors min-w-[260px]">
        <Search className="size-3.5" />
        <span>Search sites, sessions, insights…</span>
        <span className="ml-auto rounded border border-border bg-bg-surface-3 px-1.5 text-[10px] font-mono">⌘K</span>
      </button>

      <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme">
        {theme === 'dark' ? <Moon className="size-4" /> : <Sun className="size-4" />}
      </Button>

      <Button variant="ghost" size="icon" aria-label="Notifications">
        <Bell className="size-4" />
      </Button>

      <div
        className="flex size-7 items-center justify-center rounded-full bg-gradient-to-br from-accent to-[#5AC8FA] text-[11px] font-semibold text-white"
        title={me?.member.email}
      >
        {initials}
      </div>
    </header>
  );
}
